import React from 'react';
import { PageLayout, TableStudentsData } from '@BUP/components';
import { useAuth } from '@BUP/hooks';

const CoursePage = () => {
  const { user } = useAuth();
  const course = user?.courses?.name;

  return (
    <PageLayout pageName={`Mi Curso (${course})`}>
      <TableStudentsData />
    </PageLayout>
  );
};

export default CoursePage;
